import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getFillRateByNoticeTimeseriesCsv } from 'api/pulse/fillRateByNoticeTimeseries'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useFillRateByNoticeTimeseriesDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_fill_rate_by_notice_timeseries', {
        filters: query,
      })
      const data = await getFillRateByNoticeTimeseriesCsv(query)
      fileDownload(data, 'fill_rate_by_notice_timeseries.csv')
    },
  })
}
